import React , {useState , useEffect , useRef , useCallback}from 'react'
import { Grid  , Modal , Box} from '@mui/material'
import AlertHeader from '../AlertHeader'
import {  Formik } from 'formik';
import CustomAccordion from '../CustomAccordion/CustomAccordion';
import * as yup from 'yup'
import DeleteModal from "../../../shared/DeleteModal";
import { useDispatch } from 'react-redux';
import usePrompt from '../../../Hooks/usePrompt'
import { useNavigate } from "react-router-dom";
import SaveChangesModal from '../../../shared/SaveChangesModal'
import { updateAlert , deleteAlert , updateDefault, CreateAlert, getAlerts} from '../../state/actions';
import SubscriberForm from './SubscriberForm';

const CustomerSection = ({sectionName , sectionSubscribers , error , success , loadAlerts}) => {
  
    const [subscriber, setSubscriber] = useState(sectionSubscribers);
    const [openDeleteModal,setOpenDeleteModal] = useState(false)
    const [expanded, setExpanded] = useState();
    const [deleteTemplate,setDeleteTemplate] = useState(null)
    const [dirty,setDirty] = useState(false)
    const [isConfirmationModalOpen,setIsConfirmationModalOpen] = useState(false)
    const [pendingLocation, setPendingLocation] = useState(null);

      const Navigate = useNavigate();
    
      const handleBlockedNavigation = useCallback(
        (nextLocation) => {
          if (nextLocation.pathname === "/admin-tool/alerts-notifications") return true;
          if (dirty) {
            setPendingLocation(nextLocation.pathname);
            setIsConfirmationModalOpen(true);
            return false;
          }
          return true;
        },
        [dirty , setIsConfirmationModalOpen]
      );
      
      
      usePrompt(handleBlockedNavigation,dirty)
      
        
      
      //close navigation blocker handler
      const handleCloseConfirmationModal = () => {
        setIsConfirmationModalOpen(false);
        setPendingLocation(null);
      };
      
      //discard changes action handler
      const handleDiscardChanges = () => {
        setIsConfirmationModalOpen(false);
        setDirty(false);
      };
      
      //navigate to pendingLocation effect
      useEffect(() => {
        if (pendingLocation && !dirty) Navigate(pendingLocation);
      }, [Navigate, pendingLocation, dirty]);
      
    const dispatch = useDispatch()

     const formRef = useRef()
      const  handleDeleteAction = () => {
        dispatch(deleteAlert(deleteTemplate, success, error)).then(() => {
          setOpenDeleteModal(false)
          setDeleteTemplate(null)
        });  
        }

      
  

     
      
            
        
        const handleSaveChanges = (values) => {
          console.log(values)
          dispatch(updateAlert(values, success, error)).then(() => {
           setDirty(false)
    setIsConfirmationModalOpen(false)
          });
        }
        
        const validationSchema =yup.object().shape({

            text: yup.string().required("required field"),
     
         
        
      
    }); 


  return (
    <div>

<SaveChangesModal
        open={isConfirmationModalOpen}
        onClose={handleCloseConfirmationModal} 
        discardChanges={handleDiscardChanges}
        saveChanges={() => formRef.current.submitForm()}
      />

<Modal
  open={openDeleteModal}
  handleClose={() => setOpenDeleteModal(false)}
>
<DeleteModal
 title="Permenantly Delete Template"
 content={
  "Are you sure you want to delete Template? data will no longer be restored."
}
handleCloseModal={() => setOpenDeleteModal(false)}
action={handleDeleteAction}
/>


</Modal>

    <AlertHeader headline={sectionName} filter={false} />
    <Grid container direction="column" spacing={1} marginBottom={10}>
   
   <>

   <Grid item xs={12}>
   
{subscriber && React.Children.toArray(subscriber.map((notification,index) => (
  <Formik
  key={notification.id}
  innerRef={formRef}
 initialValues={{
...notification
}}
validationSchema={validationSchema}
enableReinitialize={true}
onSubmit={(values, { setSubmitting }) => {
  setSubmitting(false);
  handleSaveChanges(values);
}}

validateOnChange={false}
validateOnBlur={false}
  >
    {({ ...formikProps }) => {
                const {
                  errors,
                  values,
                  submitForm,
                  setFieldValue,         
                  setValues,
                } = formikProps;

                return (
                  <>
             
<CustomAccordion
menu={[]}
disableMenu={false}
groupName = {notification.name}
group = {notification}
key={index}
index={index}
alerts={subscriber}
values={values}
setExpanded={setExpanded}
expanded={expanded}
setDirty={setDirty}
setValues={setValues}
action = {() => submitForm()}
>
<SubscriberForm
index={index}
setFieldValue={setFieldValue}
alert={notification}
values={values}
disputeRules={subscriber}
errors={errors}
setValues={setValues}
action = {() => submitForm()}
success={success}
error={error}
setIsConfirmationModalOpen ={setIsConfirmationModalOpen}
dirty = { dirty }
setDirty = { setDirty}
isConfirmationModalOpen = {isConfirmationModalOpen} 
setPendingLocation={setPendingLocation}
  pendingLocation={pendingLocation}   

/>
</CustomAccordion>
                  </>
                )
    }}
  </Formik>
)))}
   </Grid>
   </>

</Grid>

            
    </div>
  )
}

export default CustomerSection